import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DiscoverPage } from '../../pages/discover/discover';
import { AttendPage } from '../../pages/attend/attend';
import { ApiProvider } from '../api/api'
import { ReservePage } from '../../pages/reserve/reserve';
import { SecurityPage } from '../../pages/security/security';
import { CheckoutPage } from '../../pages/checkout/checkout';
import { CheckinPage } from '../../pages/checkin/checkin';
import { RenewPage } from '../../pages/renew/renew';
import { CoRoamPatronlookupPage } from '../../pages/co-roam-patronlookup/co-roam-patronlookup';
import { CoRoamPatronsignupPage } from '../../pages/co-roam-patronsignup/co-roam-patronsignup';
import { CoBrochurePage } from '../../pages/co-brochure/co-brochure';
import { CoLibraryCardPage } from '../../pages/co-library-card/co-library-card';
import { CoSelfcheckAccountPage } from '../../pages/co-selfcheck-account/co-selfcheck-account';
import { CoSelfcheckCheckoutPage } from '../../pages/co-selfcheck-checkout/co-selfcheck-checkout';
import { CoCatalogSearchPage } from '../../pages/co-catalog-search/co-catalog-search';
import { CoEventCheckinPage } from '../../pages/co-event-checkin/co-event-checkin';
import { CoEventFinderPage } from '../../pages/co-event-finder/co-event-finder';
import { CoSelfcheckCheckinPage } from '../../pages/co-selfcheck-checkin/co-selfcheck-checkin';
import { CoPatronDetailFormPage } from '../../pages/co-patron-detail-form/co-patron-detail-form';

/*
  Generated class for the PageProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PageProvider {
  private mappings: Object;
  private siteId: Number;

  constructor(public http: HttpClient, private api: ApiProvider) {
    this.mappings={};
    this.mappings['discover']=DiscoverPage;
    this.mappings['attend']=AttendPage;
    this.mappings['reserve']=ReservePage;
    this.mappings['security']=SecurityPage;
    this.mappings['checkout']=CheckoutPage;
    this.mappings['checkin']=CheckinPage;
    this.mappings['renew']=RenewPage;
    this.mappings['brochure']=CoBrochurePage;
    this.mappings['librarycard']=CoLibraryCardPage;
    this.mappings['eventcheckin']=CoEventCheckinPage;
    this.mappings['eventfinder']=CoEventFinderPage;
    this.mappings['patronlookup']=CoRoamPatronlookupPage;
    this.mappings['patronsignup']=CoRoamPatronsignupPage;
    this.mappings['selfcheck-myaccount']=CoSelfcheckAccountPage;
    this.mappings['selfcheck-checkout']=CoSelfcheckCheckoutPage;
    this.mappings['selfcheck-checkin']=CoSelfcheckCheckinPage;
    this.mappings['catalog-search']=CoCatalogSearchPage;
    this.mappings['patron-details']=CoPatronDetailFormPage;
  }

  getPage(name){
    return this.mappings[name];
  }

  async getPageHTML(pageId:Number) :Promise<coPageParametersFull>{
    let page: any

    const query = `{
      getPageHtml(id:${pageId}){
        id, title, articleHtml, headerHtml, footerHtml
      }
    }`

    page = await this.api.query(query)
    return page.getPageHtml
  };

  async getSiteInfo(siteId: Number) : Promise<coSiteParametersFull>{
    let site: any
    this.siteId = siteId

    const query = `{
      getSiteInfo(id:${siteId}){
        id, name, alias, description, theme, header, footer, menu, page, navigation, defaultPortal, desktopPortal, mobilePortal,
        transition, hideTabs, sidebarLeft, sidebarRight, data, indexPortal, revision, lastUpdate, updatedBy, customCSS, customJS,
        customHead, googleAnalytics, favicon, externalHeader, externalFooter, titleSuffix, forceSSL
      }
    }`

    site = await this.api.query(query)
    return site.getSiteInfo
  }
}

export interface coPageParametersFull {
  id: number
  title: string
  articleHtml: string
  headerHtml?: string
  footerHtml?: string
}

export interface coSiteParametersFull {
  id: number
  name: string
  alias?: string
  description?: string
  theme: number
  header: number
  footer: number
  menu: number
  page: number
  navigation: number
  defaultPortal: number
  desktopPortal: number
  mobilePortal: number
  transition: number
  hideTabs: boolean
  sidebarLeft: number
  sidebarRight: number
  data: string
  indexPortal: number
  revision: number
  lastUpdate: string
  updatedBy: number
  customCSS?: string
  customJS?: string
  customHead?: string
  googleAnalytics?: string
  favicon?: string
  externalHeader?: string
  externalFooter?: string
  titleSuffix?: string
  forceSSL: boolean
}



// WEBPACK FOOTER //
// ./src/providers/page/page.ts